<template>
  <div class="TopPerformersTopStocks">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
        <el-card
          class="box-card expert-card"
          v-loading="is_stock_list_loading"
          id="expert_dashboard_top_stock"
        >
          <div
            class="flex label-md-bold-black stock-ranking"
            style="padding: 0 15px;"
          >
            <img
              src="../assets/images/rank0.png"
              style="height: 18px; margin-right: 10px;"
            />
            Top Stocks

            <!-- <div class="download-btn" style="margin-left: 10px;" v-if="top_stock_list.length" @click="downloadRankBoardInCSV()">
                DOWNLOAD CSV
              </div> -->

            <RankBoardExplanatory></RankBoardExplanatory>
          </div>

          <table v-if="top_stock_list.length" class="rank-board-table">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <!-- <th></th> -->
                <th></th>
                <th colspan="2">Reco</th>
              </tr>

              <tr>
                <th style="min-width: 8px;">Ranking</th>

                <th>Name</th>

                <th
                  style="min-width: 50px;"
                  :style="{
                    color:
                      active_stock_ranking_sorting == 'absolute_roi'
                        ? '#3f67f2'
                        : '',
                  }"
                >
                  <!-- <el-popover
                      placement="top"
                      title="Ranking based on Absolute ROI"
                      width="320"
                      trigger="hover"
                      content="">
                    </el-popover> -->

                  <div
                    class="cursor-pointer"
                    @click="sortTopStockTableByHeading('absolute_roi')"
                  >
                  Avg ROI
                    <i
                      class="el-icon-top"
                      v-if="active_stock_ranking_sorting == 'absolute_roi'"
                    ></i>
                  </div>
                </th>

                <!-- <th style="min-width: 80px;" :style="{ 'color': active_stock_ranking_sorting == 'accuracy' ? '#3f67f2' : '' }">

                    <el-popover
                      placement="top"
                      title="Ranking based on accuracy"
                      width="320"
                      trigger="hover"
                      content="Accuracy after adjusting error rate and updated price estimates.">
                    </el-popover>

                    <div class="cursor-pointer inline-block" @click="sortTopStockTableByHeading('accuracy')">
                      Accuracy
                      <i class="el-icon-top" v-if="active_stock_ranking_sorting == 'accuracy'"></i>
                    </div>
                  </th> -->

                <th
                  style="min-width: 110px;"
                  :style="{
                    color:
                      active_stock_ranking_sorting == 'success_rate'
                        ? '#3f67f2'
                        : '',
                  }"
                >
                  <!-- <el-popover
                      placement="top"
                      title="Ranking based on success rate"
                      width="320"
                      trigger="hover"
                      content="Success Rate is based on No. of target achieved / No. total recommendations.">
                    </el-popover> -->

                  <div
                    slot="reference"
                    class="cursor-pointer inline-block"
                    @click="sortTopStockTableByHeading('success_rate')"
                  >
                    Success Rate
                    <i
                      class="el-icon-top"
                      v-if="active_stock_ranking_sorting == 'success_rate'"
                    ></i>
                  </div>
                </th>

                <th
                  style="min-width: 50px;"
                  :style="{
                    color:
                      active_stock_ranking_sorting == 'live_reco'
                        ? '#3f67f2'
                        : '',
                  }"
                >
                  <!-- <el-popover
                      placement="top"
                      title="Ranking based on Live reco"
                      width="200"
                      trigger="hover"
                      content="Descending order.">
                    </el-popover> -->

                  <div
                    slot="reference"
                    class="cursor-pointer"
                    @click="sortTopStockTableByHeading('live_reco')"
                  >
                    Live
                    <i
                      class="el-icon-top"
                      v-if="active_stock_ranking_sorting == 'live_reco'"
                    ></i>
                  </div>
                </th>

                <th
                  style="min-width: 50px;"
                  :style="{
                    color:
                      active_stock_ranking_sorting == 'total_reco'
                        ? '#3f67f2'
                        : '',
                  }"
                >
                  <!-- <el-popover
                      placement="top"
                      title="Ranking based on Total reco"
                      width="200"
                      trigger="hover"
                      content="Descending order.">
                    </el-popover> -->

                  <div
                    slot="reference"
                    class="cursor-pointer"
                    @click="sortTopStockTableByHeading('total_reco')"
                  >
                    Total
                    <i
                      class="el-icon-top"
                      v-if="active_stock_ranking_sorting == 'total_reco'"
                    ></i>
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(stock, index) in top_stock_list"
                :key="index"
                @click="selectStock(index, stock)"
                :class="{ 'selected-row': selected_stock_index == index }"
              >
                <td class="relative">
                  <div
                    class="absolute"
                    style="top: 15px; left: 15px; right: 15px;"
                  >
                    <Hexagon :rank="stock.rank"></Hexagon>
                  </div>
                </td>

                <td class="border-right-gray" style="text-align: left">
                  <div class="capitalize">{{ stock.name }}</div>
                  <div
                    class="top-margin-5 font-weight-500"
                    style="font-size: 10px;"
                  >
                    <div>
                      <span class="label-xs-bold"
                        >₹ {{ stock.current_price }}</span
                      >&nbsp;&nbsp;
                      <span
                        :style="{
                          color:
                            stock.price_difference < 0 ? '#d60918' : '#079e3e',
                        }"
                      >
                        <span
                          class="label-xss-black"
                          v-if="stock.price_difference < 0"
                          >&#9662;</span
                        >
                        <span class="label-xss-black" v-else>&#9652;</span>
                        &nbsp;<span
                          >{{ stock.price_difference.toFixed(2) }} ({{
                            stock.price_potential.toFixed(2)
                          }}%)</span
                        >
                      </span>

                      <div
                        class="input-label-gray font-weight-500"
                        style="font-size: 9px; margin-top: 2px;"
                      >
                        {{ stock.current_date | stock_live_price_date_filter }}
                      </div>
                    </div>

                    <div class="top-margin-10">
                      <el-tag
                        v-if="stock.market_cap_size"
                        size="mini"
                        class="sector-tag ellipsis"
                        :title="stock.market_cap_size"
                        effect="plain"
                        type="info"
                        :style="{
                          background:
                            selected_stock_index == index ? '#eff5fe' : '#fff',
                        }"
                        style="height: 16px; line-height: 15px; font-size: 8px;"
                        >{{ stock.market_cap_size }}</el-tag
                      >

                      &nbsp;

                      <el-tag
                        v-if="stock.sector"
                        size="mini"
                        class="sector-tag ellipsis"
                        :title="stock.sector"
                        effect="plain"
                        type="info"
                        :style="{
                          background:
                            selected_stock_index == index ? '#eff5fe' : '#fff',
                        }"
                        style="height: 16px; line-height: 15px; font-size: 8px; max-width: 100px;"
                        >{{ stock.sector }}</el-tag
                      >
                    </div>
                  </div>
                </td>

                <td class="border-right-gray">
                  {{
                    stock.absolute_roi
                      ? stock.absolute_roi.toFixed(2) + "%"
                      : "-"
                  }}
                </td>

                <!-- <td class="border-right-gray">{{ stock.accuracy ? stock.accuracy.toFixed(2) + '%' : '-' }}</td> -->

                <td class="border-right-gray">
                  {{
                    stock.success_rate
                      ? stock.success_rate.toFixed(2) + "%"
                      : "-"
                  }}
                </td>

                <td class="primary-theme-color">{{ stock.live_reco }}</td>
                <td>{{ stock.total_reco }}</td>
              </tr>
            </tbody>
          </table>

          <el-pagination
            class="label-xs-bold text-center top-margin-10"
            v-if="top_stock_list.length && stock_rank_board_number_of_pages > 1"
            small
            :current-page.sync="stock_rank_board_page_no"
            @current-change="handleStockRankBoardCurrentPageChange"
            :page-size="stock_rank_board_entries_per_page"
            layout="prev, pager, next"
            :total="stock_rank_board_total_entries"
          >
          </el-pagination>

          <!-- if no top experts found then displayed no data -->
          <NoDataFound
            v-if="!top_stock_list.length && !is_stock_list_loading"
          ></NoDataFound>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
        <div class="selected-filter-section">
          <div class="label-xs-bold">FILTERS:</div>
          <div style="display: flex; flex-wrap: wrap; margin: 0 5px">
            <div
              v-if="filterObj.filters && filterObj.filters.length"
              class="filters-content"
              v-for="(filter, filter_index) in filterObj.filters"
              :key="filter_index"
            >
              {{ filter }}
            </div>
            <div class="filters-content" v-if="filterObj.sector">
              Sector
            </div>
            <div
              class="filters-content"
              v-if="filterObj.stocks && filterObj.stocks.length"
            >
              Stocks
            </div>
            <div
              class="filters-content"
              v-if="
                Object.keys(filterObj.target_period).length &&
                  filterObj.target_period.key != 'Long_term'
              "
            >
              {{ filterObj.target_period.key }}
            </div>
            <div class="filters-content" v-if="filterObj.term">
              {{ filterObj.term }}
            </div>
          </div>
        </div>

        <el-card
          class="stock-detail-card"
          v-if="top_stock_list.length"
          id="expert_dashboard_top_stock_falsh_card"
          v-loading="is_flash_card_details_loading"
        >
          <div class="stock-base-details">
            <div class="flex-space-between" style="flex-wrap: wrap;">
              <div class="stock-base-header">
                <Hexagon
                  class="right-margin-10"
                  :rank="stock_details.data.rank"
                ></Hexagon>
                <div>
                  <div
                    class="label-md-bold-black ellipsis cursor-pointer capitalize"
                    style="font-size: 13px; max-width: 160px;"
                    @click="goToPastRecoPage(stock_details.data.id)"
                  >
                    {{ stock_details.data.name }}
                  </div>

                  <div v-if="stock_details.data.current_price">
                    <span class="label-xs-bold"
                      >₹ {{ stock_details.data.current_price }}</span
                    >&nbsp;
                    <span
                      style="font-size: 10px;"
                      :style="{
                        color:
                          stock_details.data.price_difference < 0
                            ? '#d60918'
                            : '#079e3e',
                      }"
                    >
                      <span
                        class="label-xss-black"
                        v-if="stock_details.data.price_difference < 0"
                        >&#9662;</span
                      >
                      <span class="label-xss-black" v-else>&#9652;</span>
                      &nbsp;
                      <span
                        >{{
                          stock_details.data.price_difference.toFixed(2)
                        }}
                        ({{
                          stock_details.data.price_potential.toFixed(2)
                        }}%)</span
                      >
                    </span>
                    <div class="input-label-gray" style="font-size: 9px;">
                      {{
                        stock_details.data.modified_datetime
                          | stock_live_price_date_filter
                      }}
                    </div>
                  </div>
                </div>

                <!-- <div class="download-btn" style="margin-left: auto;" v-if="stock_details.experts.length" @click="downloadFlashCardDetailsInCSV()">
                    DOWNLOAD CSV
                  </div> -->
              </div>
            </div>

            <div class="flex-space-between top-margin-15">
              <div>
                <el-tag
                  v-if="stock_details.data.market_cap_size"
                  size="mini"
                  class="sector-tag ellipsis"
                  :title="stock_details.data.market_cap_size"
                  effect="plain"
                  type="info"
                  style="background: #eff5fe; height: 16px; line-height: 15px; font-size: 8px;"
                  >{{ stock_details.data.market_cap_size }}</el-tag
                >

                &nbsp;

                <el-tag
                  v-if="stock_details.data.sector"
                  size="mini"
                  class="sector-tag ellipsis"
                  :title="stock_details.data.sector"
                  effect="plain"
                  type="info"
                  style="background: #eff5fe; height: 16px; line-height: 15px; font-size: 8px;"
                  >{{ stock_details.data.sector }}</el-tag
                >
              </div>
            </div>

            <div class="flex-space-between top-margin-15">
              <div>
                <span class="label-md-bold-black">{{
                  stock_details.data.absolute_roi
                    ? stock_details.data.absolute_roi.toFixed(2) + "%"
                    : "-"
                }}</span>
                <!-- <span class="label-md-bold-black" style="font-size: 10px;"> {{ getYearStringFromNumberOfDays(stock_details.data.performance_period_in_days_sum) }} </span> -->
                <div class="input-label-gray">Avg ROI</div>
              </div>

              <!-- <div>
                  <span class="label-md-bold-black">{{  stock_details.data.annual_roi ? stock_details.data.annual_roi + '%' : '-' }}</span>
                  <div class="input-label-gray">Annualised ROI</div>
                </div> -->

              <div>&nbsp;</div>
              <div>&nbsp;&nbsp;&nbsp;</div>
            </div>

            <div class="flex-space-between top-margin-15">
              <!-- <div>
                  <span class="label-md-bold-black">{{ stock_details.data.accuracy ? stock_details.data.accuracy.toFixed(2) + '%' : '-' }}</span>
                  <div class="input-label-gray">Accuracy</div>
                </div> -->

              <div>
                <span class="label-md-bold-black">{{
                  stock_details.data.success_rate
                    ? stock_details.data.success_rate.toFixed(2) + "%"
                    : "-"
                }}</span>
                <div class="input-label-gray">Success Rate</div>
              </div>

              <div>
                <div class="text-center">
                  <span
                    class="primary-theme-color font-06rem"
                    title="Live recommendations"
                    >Live
                  </span>
                  <span class="primary-theme-color font-08rem">{{
                    stock_details.data.live_reco
                  }}</span>
                  &nbsp;

                  <span class="font-06rem" title="Total recommendations"
                    >Total
                  </span>
                  <span class="font-08rem">{{
                    stock_details.data.total_reco
                  }}</span>
                  <div class="input-label-gray" style="font-size: 10px;">
                    Recommendations
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="stock-accuracy-detail-wrapper"
            v-loading="is_stocks_details_experts_list_loading"
          >
            <el-select
              v-if="top_stock_list.length"
              v-model="expert_details_category"
              placeholder="Select"
              size="mini"
              class="mini-select"
              @change="changeExpertDetailsCategoryDropdown()"
              style="width: 80%;"
            >
              <el-option
                v-for="(category,
                category_index) in expert_details_category_list"
                :key="category_index"
                :label="category.lable"
                :value="category.value"
              ></el-option>
            </el-select>

            <div v-if="stock_details.experts.length">
              <!-- <div class="label-xs-black font-weight-600 header-title-color">Max Recommendation (based on stocks)</div> -->

              <table class="top-margin-5">
                <thead>
                  <tr>
                    <th>Expert Name</th>
                    <th v-if="expert_details_category == 'accuracy'">
                      Accuracy
                    </th>
                    <!-- <th v-if="expert_details_category == 'rating'">Rating</th> -->
                    <th v-if="expert_details_category == 'absolute_roi'">
                      Avg ROI
                    </th>
                    <th v-if="expert_details_category == 'success_rate'">
                      Success Rate
                    </th>
                    <th
                      v-if="
                        expert_details_category == 'total_reco' ||
                          expert_details_category == 'live_reco'
                      "
                    >
                      LR/TR
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(item, index) in stock_details.experts"
                    :key="index"
                  >
                    <td style="width: 90px;">
                      <span
                        class="label-md-black capitalize"
                        style="font-size: 0.8rem;"
                        @click="redirectExpertToPastRecoPage(item)"
                        >{{ item.full_name }}</span
                      >
                      <div>
                        <span class="input-label-gray capitalize">{{
                          item.profession
                        }}</span>
                      </div>
                    </td>

                    <td
                      style="width: 90px;"
                      class="label-xss-black"
                      v-if="expert_details_category == 'accuracy'"
                    >
                      {{ item.accuracy ? item.accuracy.toFixed(2) + "%" : "-" }}

                      <div v-if="item.total_result">
                        (Total Results - {{ item.total_result }})
                      </div>
                    </td>

                    <td
                      style="width: 90px;"
                      class="label-xss-black"
                      v-if="expert_details_category == 'success_rate'"
                    >
                      {{
                        item.success_rate
                          ? item.success_rate.toFixed(2) + "%"
                          : "-"
                      }}
                    </td>

                    <td
                      style="width: 90px;"
                      class="label-xss-black"
                      v-if="expert_details_category == 'absolute_roi'"
                    >
                      {{
                        item.absolute_roi
                          ? item.absolute_roi.toFixed(2) + "%"
                          : "-"
                      }}
                    </td>

                    <td
                      style="width: 90px;"
                      class="label-xss-black"
                      v-if="
                        expert_details_category == 'live_reco' ||
                          expert_details_category == 'total_reco'
                      "
                    >
                      <div class="flex flex-center">
                        <div class="flex flex-space-between">
                          <div class="primary-theme-color right-margin-20">
                            {{ item.live_reco }}
                          </div>
                          <div>{{ item.total_reco }}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <el-pagination
                class="label-xs-bold text-center top-margin-10"
                v-if="stock_details_total_entries > 3"
                small
                :current-page.sync="stock_details_stock_rank_board_page_no"
                @current-change="handleStockDetailsCurrentPageChange"
                :page-size="stock_details_entries_per_page"
                layout="prev, pager, next"
                :total="stock_details_total_entries"
              >
              </el-pagination>
            </div>

            <!-- if no stocks found then displayed no data -->
            <div
              class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20"
              v-if="
                !is_stocks_details_experts_list_loading &&
                  !stock_details.experts.length
              "
            >
              No data available
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="15">
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-card class="box-card relative" style="min-height: 300;">
          <div class="flex-space-between">
            <div class="flex">
              <div class="label-md-bold-black">
                <div class="flex">
                  <img
                    src="../assets/images/asset12.png"
                    style="height: 19px; margin-right: 10px;"
                  />
                  Avg ROI
                  <!-- <span class="font-06rem left-margin-5">(Live reco)</span> -->
                </div>
              </div>
            </div>
          </div>

          <div
            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
            v-if="!is_roi_graph_data_available"
            style="top: 100px; left: 0; right: 0;"
          >
            No data available
          </div>

          <!-- antestimate graph details dialog -->
          <el-card
            class="box-card antestimate-details-card"
            shadow="always"
            v-if="is_antestimate_details_opened"
            v-loading="is_antestimate_graph_details_loading"
          >
            <div
              class="absolute cursor-pointer close-btn"
              @click="closeAntestimateDetailsDialog()"
            >
              &#x2715;
            </div>
            <div style="padding: 20px 20px 0 20px;">
              <div class="label-md-bold-black">Antestimate</div>

              <div class="flex flex-wrap" style="padding: 0 10px;">
                <div style="flex: 1 1 0px;">
                  <div
                    ref="antestimate_details_graph"
                    style="width: 100%; height: 100px;"
                  ></div>
                </div>
                <div style="flex: 1 1 0px; padding-left: 35px;">
                  <div class="flex top-margin-5">
                    <div
                      class="progress-bar-legends"
                      style="background-color: #2dcab3;"
                    >
                      &nbsp;
                    </div>
                    <span style="font-size: 13px;">{{
                      antestimate_details.Buy
                    }}</span
                    >&nbsp;<span
                      class="input-label-gray"
                      style="font-size: 13px;"
                      >Buy</span
                    >
                  </div>
                  <div class="flex top-margin-5">
                    <div
                      class="progress-bar-legends"
                      style="background-color: #f2bd4c;"
                    >
                      &nbsp;
                    </div>
                    <span style="font-size: 13px;">{{
                      antestimate_details.Sell
                    }}</span
                    >&nbsp;<span
                      class="input-label-gray"
                      style="font-size: 13px;"
                      >Sell</span
                    >
                  </div>
                  <div class="flex top-margin-5">
                    <div
                      class="progress-bar-legends"
                      style="background-color: #ed5950;"
                    >
                      &nbsp;
                    </div>
                    <span style="font-size: 13px;">{{
                      antestimate_details.Hold
                    }}</span
                    >&nbsp;<span
                      class="input-label-gray"
                      style="font-size: 13px;"
                      >Hold</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div
              class="clearfix flex-space-around text-center"
              style="border-top: 1px solid #ddd; padding: 10px 20px;"
            >
              <div>
                <div class="label-xs-bold">
                  {{
                    antestimate_details.range.length
                      ? antestimate_details.range[0]
                      : 0
                  }}
                  -
                  {{
                    antestimate_details.range.length
                      ? antestimate_details.range[1]
                      : 0
                  }}
                </div>
                <div class="input-label-gray">Range</div>
              </div>

              <!-- <div>
                  <div class="label-xs-bold">2nd Q 20-21</div>
                  <div class="input-label-gray">Target period</div>
                </div> -->
            </div>
          </el-card>

          <div class="graph-container">
            <div ref="roi_graph" style="width: 100%; height: 285px;"></div>
          </div>

          <div class="axis-description">(0 - No data available)</div>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-card class="box-card relative">
          <div class="flex label-md-bold-black">
            <img
              src="../assets/images/asset11.png"
              style="height: 19px; margin-right: 10px;"
            />
            Trending Stocks
            <span class="font-06rem left-margin-5">(Based on searches)</span>
          </div>

          <div
            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
            v-if="!is_trending_stock_graph_data_available"
            style="top: 100px!important; left: 0; right: 0;"
          >
            No data available
          </div>

          <div
            ref="trending_stock_graph"
            style="width: 100%; height: 285px;"
          ></div>

          <div class="axis-description">(0 - No data available)</div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="15">
      <!-- <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-card class="box-card relative">
            <div class="flex-space-between">
              <div class="label-md-bold-black flex">
                <img src="../assets/images/asset1.png" style="height: 19px; margin-right: 10px;" />
                Accuracy
              </div>
            </div>

            <div class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute" v-if="!is_accuracy_graph_data_available" style="top: 100px!important; left: 0; right: 0;">
              No data available
            </div>

            <div class="graph-container">
              <div ref="accuracy_graph" style="width: 100%; height: 320px;"></div>
            </div>

            <div class="axis-description">(0% - No data available)</div>
          </el-card>
        </el-col> -->

      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-card class="box-card relative" style="min-height: 300;">
          <div class="flex-space-between">
            <div class="flex">
              <div class="label-md-bold-black">
                <div class="flex">
                  <img
                    src="../assets/images/asset2.png"
                    style="height: 19px; margin-right: 10px;"
                  />
                  Max Recommendation
                </div>
              </div>
            </div>
          </div>

          <div class="top-margin-15 flex-center">
            <div
              style="background-color: #09a6d0; border-radius: 3px; width: 12px; height: 12px;"
            >
              &nbsp;
            </div>
            &nbsp;<span class="label-xss-black font-weight-600">Live Reco</span>
            &nbsp; &nbsp;
            <div
              style="background-color: #e55575; border-radius: 3px; width: 12px; height: 12px;"
            >
              &nbsp;
            </div>
            &nbsp;<span class="label-xss-black font-weight-600"
              >Total Reco</span
            >
          </div>

          <div
            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
            v-if="!is_max_reco_graph_data_available"
            style="top: 100px!important; left: 0; right: 0;"
          >
            No data available
          </div>

          <div class="graph-container">
            <div
              ref="max_reco_expert_graph"
              style="width: 100%; height: 285px;"
            ></div>
          </div>

          <div class="axis-description">(0 - No data available)</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var echarts = require("echarts");
import NoDataFound from "@/components/NoDataFound.vue";
import Hexagon from "@/components/Hexagon.vue";
import RankBoardExplanatory from "@/components/RankBoardExplanatory.vue";
import { graphData } from "../mixins/BarGraphData";
import { serverAddr, serverHostName, serverAddrForCSV } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import { EventBus } from "../eventBus";
import { screenSize } from "../mixins/ScreenSize.js";
import domtoimage from "dom-to-image";
import { HelperNetworkCallBack } from "../mixins/Helper";

export default {
  name: "TopPerformersTopStocks",
  components: {
    NoDataFound,
    Hexagon,
    RankBoardExplanatory,
  },

  mixins: [graphData, filterCallBack, screenSize, HelperNetworkCallBack],

  props: ["active_sub_menu", "active_period"],

  data() {
    return {
      active_stock_ranking_sorting: "absolute_roi",

      top_stock_list: [],

      filter_list: [
        {
          title: "Search stock",
        },
        {
          title: "Sectors",
        },
        {
          title: "Market cap",
          filter: ["Large Cap", "Mid Cap", "Small Cap"],
        },
        {
          title: "Reco type",
          filter: ["Buy", "Sell"],
        },
        // {
        //   title: "Term"
        // },
        {
          title: "Target period",
        },
      ],

      stock_details: {
        data: {},
        experts: [],
      },

      antestimate_details: {
        Buy: "",
        Sell: "",
        Hold: "",
        range: [],
      },

      filterObj: {
        filters: [],
        sector: "",
        term: "",
        target_period: {},
        selected_filters_title: [],
      },

      ranking_board_stock_id_list: [],

      is_stock_list_loading: false,
      is_stocks_details_experts_list_loading: false,
      is_flash_card_details_loading: false,

      is_antestimate_details_opened: false,
      selected_antestimate_series: {},
      is_antestimate_graph_details_loading: false,

      selected_stock_index: 0,

      selected_filters: [],

      stock_rank_board_page_no: 1,
      stock_rank_board_number_of_pages: null,
      stock_rank_board_entries_per_page: 5,
      stock_rank_board_total_entries: null,

      stock_details_stock_rank_board_page_no: 1,
      stock_details_stock_rank_board_number_of_pages: null,
      stock_details_entries_per_page: 3,
      stock_details_total_entries: null,

      expert_details_category: "absolute_roi",
      expert_details_category_list: [
        // {
        //   lable: 'Based on overall Rating',
        //   value: 'rating'
        // },
        {
          lable: "Based on ROI",
          value: "absolute_roi",
        },
        // {
        //   lable: 'Based on Accuracy',
        //   value: 'accuracy'
        // },
        {
          lable: "Based on Success Rate",
          value: "success_rate",
        },
        {
          lable: "Based on live Recommendation",
          value: "live_reco",
        },
        {
          lable: "Based on total Recommendation",
          value: "total_reco",
        },
      ],

      max_reco_graph_instance: null,
      accuracy_graph_instance: null,
      roi_graph_instance: null,
      antestimate_details_graph_instance: null,
      trending_stock_graph_instance: null,

      max_reco_graph_option: "Overall",
      antestimate_accuracy_graph_option: "Month",

      is_max_reco_graph_data_available: true,
      is_roi_graph_data_available: true,
      is_accuracy_graph_data_available: true,
      is_trending_stock_graph_data_available: true,

      reco_type_option_list: [
        {
          label: "Buy",
          value: "Buy",
        },
        {
          label: "Sell",
          value: "Sell",
        },
        // {
        //   label: "Hold",
        //   value: "Hold",
        // },
        {
          label: "Overall",
          value: "Overall",
        },
      ],
      target_period_option_list: [
        {
          label: "Month",
          value: "Month",
        },
        {
          label: "Week",
          value: "Week",
        },
        {
          label: "Quarter",
          value: "Quarter",
        },
        {
          label: "Overall",
          value: "Overall",
        },
      ],
    };
  },

  mounted() {
    // emitted filter list from here to HomePageSideBar.vue
    this.$emit("filters", this.filter_list);

    EventBus.$on("emitSelectedFilters", (filterObj) => {
      this.filterObj = JSON.parse(JSON.stringify(filterObj));

      // reset graph option dropdown
      // this.max_reco_graph_option  = 'Overall';
      // this.antestimate_accuracy_graph_option = 'Month';

      this.stock_rank_board_page_no = 1; //reset page no to 1
      this.stock_details_stock_rank_board_page_no = 1;

      this.is_antestimate_details_opened = false; //closed antestimate details graph dialog

      this.getStockAntsTopStockList(); //get top stock ranking api called
    });

    this.initGraphInstance();

    this.getStockAntsTopStockList(); //get top stock ranking api called

    //called get trending stock graph data
    this.getTrendingStockGraphData();
  },

  watch: {
    active_period() {
      this.getStockAntsTopStockList();
    },
  },

  methods: {
    download_to_image(node_id) {
      var node = document.getElementById(node_id);

      domtoimage
        .toPng(node)
        .then((dataUrl) => {
          var element = document.createElement("a");
          element.setAttribute("href", dataUrl);
          element.setAttribute("download", node_id + ".png"); //node id as a name of image

          element.style.display = "none";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        })
        .catch(function(error) {
          console.error("oops, something went wrong!", error);
        });
    },

    //function to download rank board details in csv
    downloadRankBoardInCSV() {
      this.is_stock_list_loading = true; //enabled loader;
      serverAddr
        .post("/stockants_pro/stock-base-ranking-csv/", {
          duration: this.filterObj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          sector: this.filterObj.sector,
          ranking_by: this.active_stock_ranking_sorting,
          stock_id_list: this.filterObj.stocks ? this.filterObj.stocks : [],
          filters: this.filterObj.filters,
          target_period: this.filterObj.target_period,
        })
        .then((response) => {
          if (response.status == 200) {
            window.open(response.data.url, "_blank");
            // this.downloadCsv(response, 'stockants top stocks rank board.csv');
          }
          this.is_stock_list_loading = false; //disabled loader;
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_stock_list_loading = false; //disabled loader;
          }.bind()
        );
    },

    //function to download flash card details in csv
    downloadFlashCardDetailsInCSV() {
      this.is_flash_card_details_loading = true; //enabled loader
      serverAddr
        .post("/stockants_pro/expert-stock-detail-card-csv/", {
          duration: this.filterObj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          card_sub_topic: this.active_stock_ranking_sorting,
          stock_id: this.stock_details.data.id,
          filters: this.filterObj.filters,
          sector: this.filterObj.sector,
          target_period: this.filterObj.target_period,
        })
        .then((response) => {
          if (response.status == 200) {
            window.open(response.data.url, "_blank");
            // this.downloadCsv(response, 'stockants top stocks flash card.csv');
          }
          this.is_flash_card_details_loading = false; //disabled loader
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_flash_card_details_loading = false; //disabled loader
          }.bind()
        );
    },

    downloadCsv(response, file_name) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(response.data)
      );
      element.setAttribute("download", file_name);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    //function to redirect on other expert past reco track page
    redirectExpertToPastRecoPage(expert) {
      if (
        !Object.keys(this.subscribedPlanDetails).length ||
        this.subscribedPlanDetails.plan == "Lite"
      ) {
        this.$store.commit("commitSubscribPlanDialogVisibility", true);
        return;
      }

      if (expert.id == this.userProfile.id) {
        this.$router.push({ name: "pastRecommendations" });
      } else {
        this.$router.push({
          name: "expertsPastRecommendations",
          query: { user_id: expert.id, user: expert.response_type },
        });
      }
    },

    //function to redirect on other expert past reco track page
    //if term is short term selected from filter then redirect to other expert short term data track page
    //if term is long term selected from filter then redirect to other expert long data track term page
    //if term filter is not selected then redirect to other expert short term data track page
    //passed stock id as a param
    goToPastRecoPage(stock_id) {
      if (
        !Object.keys(this.subscribedPlanDetails).length ||
        this.subscribedPlanDetails.plan == "Lite"
      ) {
        this.$store.commit("commitSubscribPlanDialogVisibility", true);
        return;
      }

      this.$router.push({
        name: "expertsPastRecommendations",
        query: { stock_id: stock_id },
      });
    },

    // calls when clicked on stock ranking boards table header
    sortTopStockTableByHeading(heading) {
      if (heading == "rating") {
        this.active_stock_ranking_sorting = heading;
      } else if (heading == "absolute_roi") {
        this.active_stock_ranking_sorting = heading;
      } else if (heading == "accuracy") {
        this.active_stock_ranking_sorting = heading;
      }
      if (heading == "success_rate") {
        this.active_stock_ranking_sorting = heading;
      } else if (heading == "total_reco") {
        this.active_stock_ranking_sorting = heading;
      } else if (heading == "live_reco") {
        this.active_stock_ranking_sorting = heading;
      }

      this.expert_details_category = heading;

      this.stock_rank_board_page_no = 1; //reset page no to 1
      this.stock_details_stock_rank_board_page_no = 1; //reset page no to 1

      this.is_antestimate_details_opened = false; //closed antestimate details graph dialog

      this.getStockAntsTopStockList();
    },

    handleStockRankBoardCurrentPageChange(val) {
      // for lite plan or non subscribers restricted to access pagination
      if (
        !Object.keys(this.subscribedPlanDetails).length ||
        this.subscribedPlanDetails.plan == "Lite"
      ) {
        this.stock_rank_board_page_no = 1; //reset to page no 1
        this.$store.commit("commitSubscribPlanDialogVisibility", true);
        return;
      }

      this.stock_rank_board_page_no = val;
      this.stock_details_stock_rank_board_page_no = 1; //reset page no to 1
      this.is_antestimate_details_opened = false; //closed antestimate details graph dialog
      this.getStockAntsTopStockList();
    },

    selectStock(index, item) {
      this.selected_sector_index = null; //to inactive seclected row of sector rank board

      this.selected_stock_index = index; //changed selected stocks row index
      this.stock_details.data = {};
      this.stock_details.data = JSON.parse(JSON.stringify(item)); //assigned selected stocks data

      this.is_stocks_details_experts_list_loading = true; //enabled loader

      this.stock_details_stock_rank_board_page_no = 1; //set page no to 1

      this.check_selected_item_details_type = "STOCK"; //to enable details in right flash card by stock

      this.getExpertsListRecommendedForSelectedStock(); //called api to get selected experts stocks
    },

    changeExpertDetailsCategoryDropdown(index, item) {
      this.is_stocks_details_experts_list_loading = true; //enabled loader

      this.stock_details_stock_rank_board_page_no = 1; //set page no to 1

      this.getExpertsListRecommendedForSelectedStock(); //called api to get selected experts stocks
    },

    //api called to get top experts on platform
    getStockAntsTopStockList() {
      this.is_stock_list_loading = true; //enabled loader
      this.is_stocks_details_experts_list_loading = true; //enabled loader

      // variables to show no data found labels on graph
      this.is_max_reco_graph_data_available = true;
      this.is_roi_graph_data_available = true;
      this.is_accuracy_graph_data_available = true;
      ///////////////////////////////////////////

      // this.accuracy_graph_instance.showLoading(this.loader_default); //enabled loader
      this.roi_graph_instance.showLoading(this.loader_default); //enabled loader
      this.max_reco_graph_instance.showLoading(this.loader_default); //enabled loader

      serverAddr
        .post("/performers/v1/stock/ranking_board/", {
          page_number: this.stock_rank_board_page_no,
          page_per_entries: this.stock_rank_board_entries_per_page,
          duration: this.filterObj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          sector: this.filterObj.sector,
          ranking_by: this.active_stock_ranking_sorting,
          stock_id_list: this.filterObj.stocks ? this.filterObj.stocks : [],
          filters: this.filterObj.filters,
          target_period: this.filterObj.target_period,
          period: this.active_period
        })
        .then((response) => {
          if (response.data.status) {
            this.top_stock_list = response.data.data;

            this.selected_stock_index = 0;

            this.ranking_board_stock_id_list = [];

            this.top_stock_list.forEach((element) => {
              if (this.ranking_board_stock_id_list.indexOf(element.id) == -1) {
                this.ranking_board_stock_id_list.push(element.id);
              }
            });

            //called get accuracy graph api, sent stock id list displayed on ranking board table
            // this.getAccuracyGraphData();

            //called get max recommendation graph data sent stock id list displayed on ranking board table
            this.getMaxRecoExpertGraphData();

            //called get ROI graph data sent stock id list displayed on ranking board table
            this.getROIGraphData();

            if (this.top_stock_list.length) {
              this.stock_details.data = JSON.parse(
                JSON.stringify(this.top_stock_list[0])
              );
              this.getExpertsListRecommendedForSelectedStock(); //called api to get selected experts stocks
            }

            this.stock_rank_board_page_no =
              response.data.pagination.current_page;
            this.stock_rank_board_number_of_pages =
              response.data.pagination.total_pages;
            this.stock_rank_board_total_entries =
              response.data.pagination.total_entries;
            this.is_stock_list_loading = false; //disabled loader
          } else {
            this.top_stock_list = [];
            this.is_stock_list_loading = false; //disabled loader
            this.ranking_board_stock_id_list = [];
            this.is_stocks_details_experts_list_loading = false; //disabled loader

            // this.accuracy_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.roi_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.max_reco_graph_instance.hideLoading(this.loader_default); //disabled loader

            // this.clearAccuracyGraphData();
            this.clearMaxRecoGraphData(); //clear graph data e.g. xaxis, yaxis, series
            this.clearROIGraphData();

            this.reRenderAccuracyGraphInstance();
            this.reRenderMaxRecoExpertGraphInstance();
            this.reRenderROIGraphInstance();

            // variables to show no data found labels on graph
            this.is_accuracy_graph_data_available = false;
            this.is_max_reco_graph_data_available = false;
            this.is_roi_graph_data_available = false;
            ///////////////////////////////////////////
          }
        })
        .catch(
          function(error) {
            console.log(error);
            this.top_stock_list = [];
            this.is_stock_list_loading = false; //disabled loader
            this.ranking_board_stock_id_list = [];
            this.is_stocks_details_experts_list_loading = false; //disabled loader

            // this.accuracy_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.max_reco_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.roi_graph_instance.hideLoading(this.loader_default); //disabled loader

            // this.clearAccuracyGraphData();
            this.clearROIGraphData();
            this.clearTrendingSectorGraphData();

            this.reRenderAccuracyGraphInstance();
            this.reRenderMaxRecoExpertGraphInstance();
            this.reRenderROIGraphInstance();

            // variables to show no data found labels on graph
            this.is_accuracy_graph_data_available = false;
            this.is_max_reco_graph_data_available = false;
            this.is_roi_graph_data_available = false;
            ///////////////////////////////////////////
          }.bind(this)
        );
    },

    //function to get more stocks for selcted expert
    handleStockDetailsCurrentPageChange(val) {
      // for lite plan or non subscribers restricted to access pagination
      if (
        !Object.keys(this.subscribedPlanDetails).length ||
        this.subscribedPlanDetails.plan == "Lite"
      ) {
        this.stock_details_stock_rank_board_page_no = 1; //reset to page no 1
        this.$store.commit("commitSubscribPlanDialogVisibility", true);
        return;
      }

      this.stock_details_stock_rank_board_page_no = val;
      this.is_stocks_details_experts_list_loading = true; //enabled loader
      this.getExpertsListRecommendedForSelectedStock();
    },

    // api to get selected stocks recommeded by experts list
    getExpertsListRecommendedForSelectedStock() {
      serverAddr
        .post("/performers/v1/stock/flash_card/", {
          duration: this.filterObj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          card_sub_topic: this.expert_details_category,
          stock_id: this.stock_details.data.id,
          page_number: this.stock_details_stock_rank_board_page_no,
          page_per_entries: this.stock_details_entries_per_page,
          filters: this.filterObj.filters,
          sector: this.filterObj.sector,
          target_period: this.filterObj.target_period,
          period: this.active_period
        })
        .then((response) => {
          if (response.data.status) {
            this.stock_details.experts = []; //cleared before filling new data

            this.stock_details.experts = response.data.data;

            this.is_stocks_details_experts_list_loading = false; //disabled loader

            this.stock_details_total_entries =
              response.data.pagination.total_entries;
            this.stock_details_stock_rank_board_number_of_pages =
              response.data.pagination.total_pages;
            this.stock_details_stock_rank_board_page_no =
              response.data.pagination.current_page;
          } else {
            this.is_stocks_details_experts_list_loading = false; //disabled loader
            this.stock_details.experts = [];
          }
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_stocks_details_experts_list_loading = false; //disabled loader
            this.stock_details.experts = [];
          }.bind(this)
        );
    },

    initGaugeGraph() {
      let antestimate_details_graph_container = this.$refs[
        "antestimate_details_graph"
      ];
      this.antestimate_details_graph_instance = echarts.init(
        antestimate_details_graph_container,
        null,
        this.initOptions
      );

      setTimeout(() => {
        // api to get antestimate graph details to display on meter/gauge graph
        this.getAntestimateDetailsGraphData();
      }, 1000);
    },

    closeAntestimateDetailsDialog() {
      this.is_antestimate_details_opened = false;
    },

    //initialize graph
    initGraphInstance() {
      let max_reco_expert_graph_container = this.$refs["max_reco_expert_graph"];
      this.max_reco_graph_instance = echarts.init(
        max_reco_expert_graph_container,
        null,
        this.initOptions
      );

      let roi_graph_container = this.$refs["roi_graph"];
      this.roi_graph_instance = echarts.init(
        roi_graph_container,
        null,
        this.initOptions
      );

      // this.roi_graph_instance.on('click', 'series', function (params) {

      //   this.selected_antestimate_series = params;
      //   this.is_antestimate_details_opened = true;

      //   this.is_antestimate_graph_details_loading = true;   //enabled loader

      //   setTimeout(() =>{
      //     // function to init gauge graph for antestimate details meter graph
      //     this.initGaugeGraph();
      //   }, 1000)
      // }.bind(this));

      // this.roi_graph_instance.on('mouseout', 'series', function (params) {
      //   this.closeAnestimateGraphDetailsDialog();
      // }.bind(this));

      // let accuracy_graph_container = this.$refs["accuracy_graph"];
      // this.accuracy_graph_instance = echarts.init(
      //   accuracy_graph_container,
      //   null,
      //   this.initOptions
      // );

      let trending_stock_graph_container = this.$refs["trending_stock_graph"];
      this.trending_stock_graph_instance = echarts.init(
        trending_stock_graph_container,
        null,
        this.initOptions
      );
    },

    clearTrendingStockGraphData() {
      this.custom_bar_graph_series_xaxis.data = [];
      this.custom_bar_graph_series.data = [];
      this.reRenderTrendingStockGraphInstance();
    },

    // clear max reco graph data
    // clearMaxRecoGraphData() {
    //     this.stacked_bar_graph_series.data = [];
    //     this.stacked_bar_graph_xaxis.data = [];
    //     this.reRenderMaxRecoExpertGraphInstance();
    // },

    clearMaxRecoGraphData() {
      this.stacked_bar_graph_series = [];
      this.stacked_bar_graph_dataset.source = [];
      this.reRenderMaxRecoExpertGraphInstance();
    },

    // cleares graph data e.g. x_axis, y_axis, legends
    clearROIGraphData() {
      this.horizontal_bar_graph_yaxis_C.data = [];
      this.horizontal_bar_graph_series_C[0].data = [];
      this.reRenderROIGraphInstance();
    },

    // cleares graph data e.g. x_axis, y_axis, legends
    clearAntestimateDetailsGraphData() {
      this.gauge_graph_series = [];
      this.reRenderAntestimateDetailsGraphInstance();
    },

    // cleares graph data e.g. x_axis, y_axis, legends
    // clearAccuracyGraphData() {
    //   this.horizontal_bar_graph_yaxis_A.data = [];
    //   this.horizontal_bar_graph_series_A[0].data = [];
    //   this.reRenderAccuracyGraphInstance();
    // },

    //refresh graph instance
    clearTrendingStockGraphInstance: function() {
      this.trending_stock_graph_instance.clear();
    },

    //refresh graph instance
    clearMaxRecoGraphInstance: function() {
      this.max_reco_graph_instance.clear();
    },

    //refresh graph instance
    // clearAccuracyGraphInstance: function() {
    //   this.accuracy_graph_instance.clear();
    // },

    //refresh graph instance
    clearROIGraphInstance: function() {
      this.roi_graph_instance.clear();
    },

    //refresh graph instance
    clearAntestimateDetailsGraphInstance: function() {
      this.antestimate_details_graph_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    // reRenderAccuracyGraphInstance: function() {
    //   this.clearAccuracyGraphInstance();
    //   this.accuracy_graph_instance.setOption(this.horizontalBarGraphPartA);
    // },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderAntestimateDetailsGraphInstance: function() {
      this.clearAntestimateDetailsGraphInstance();
      this.antestimate_details_graph_instance.setOption(this.gaugeGraph);
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderMaxRecoExpertGraphInstance: function() {
      this.clearMaxRecoGraphInstance();
      this.max_reco_graph_instance.setOption(this.stackedBarGraph);
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderROIGraphInstance: function() {
      this.clearROIGraphInstance();
      this.roi_graph_instance.setOption(this.horizontalBarGraphPartC);
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderTrendingStockGraphInstance: function() {
      this.clearTrendingStockGraphInstance();
      this.trending_stock_graph_instance.setOption(this.customBarGraph);
    },

    //api to get accuracy graph data
    getAccuracyGraphData() {
      if (this.top_stock_list.length) {
        // this.clearAccuracyGraphData();  //clear graph data e.g. xaxis, yaxis, series
        // this.accuracy_graph_instance.hideLoading(this.loader_default);     //disabled loader

        this.horizontal_graph_A_normalised_axis = false; //to show custom formatter

        this.horizontal_bar_graph_xaxis_A.axisLabel.formatter = "{value}%"; //set formatter to xaxis

        this.top_stock_list.forEach((element, index) => {
          let obj = {};
          obj.name = element.name;
          obj.value = element.accuracy ? element.accuracy.toFixed(2) : 0;
          obj.itemStyle = { color: this.horizontal_bar_graph_colors[index] };
          obj.label = {
            show: true,
            position: "right",
            fontSize: "10",
            color: "#000",
            formatter: "{c} %",
          };

          this.horizontal_bar_graph_yaxis_A.data.push(element.name);
          this.horizontal_bar_graph_series_A[0].data.push(obj);
        });
      } else {
        this.is_accuracy_graph_data_available = false;
      }

      this.reRenderAccuracyGraphInstance();
    },

    //api to get max reco graph data
    getMaxRecoExpertGraphData() {
      if (this.top_stock_list.length) {
        this.clearMaxRecoGraphData(); //clear graph data e.g. xaxis, yaxis, series
        this.max_reco_graph_instance.hideLoading(this.loader_default); //disabled loader

        let max_reco = [];

        let x_axis = ["experts"];

        // to show axis lables vertically
        this.$set(this.stacked_bar_graph_xaxis.axisLabel, "rotate", 90);
        this.$set(this.stacked_bar_graph_xaxis.axisLabel, "margin", 10);

        for (var i = 0; i < this.top_stock_list.length; i++) {
          x_axis.push(this.top_stock_list[i].name);

          let live_reco = this.top_stock_list[i].live_reco
            ? this.top_stock_list[i].live_reco
            : 0;
          let total_reco = this.top_stock_list[i].total_reco
            ? this.top_stock_list[i].total_reco
            : 0;
          let total = total_reco + live_reco - live_reco;

          max_reco.push([this.top_stock_list[i].name, live_reco, total]);
        }

        // if max reco lenght is 1 then add this dummy value
        //there is issue with displaying single user's 0 value
        //two y axis values can't be plot on single x axis thats why we pushed one dummy value
        if (max_reco.length == 1) {
          x_axis.push("Dummy");
        }

        this.stacked_bar_graph_dataset.source = max_reco;

        [0, 1].forEach((element, index) => {
          let obj = {};
          obj.name = x_axis[index + 1];
          obj.type = "bar";
          obj.seriesLayoutBy = "column";
          obj.barWidth = 35;
          obj.stack = "stack 1";
          obj.label = {
            show: true,
            position: "top",
            color: "#000",
            fontSize: "10",
            align: "right",
            // padding: [0,0,3,0],
            verticalAlign: "top",
            formatter: function(value, index) {
              if (value.componentIndex) {
                //for stacked graph.. componentIndex 0 is first graph and componentIndex 1 second graph..for graph 1 displayd total of graph one and graph second
                return `${value.data[1] + value.data[2]}`;
              } else if (value.componentIndex == 0) {
                // return (`${value.data[1]}`);
                return "";
              } else {
                return "";
              }
            },
          };
          this.stacked_bar_graph_series.push(obj);
        });
        this.stacked_bar_graph_dataset.source.unshift(x_axis);
      } else {
        this.clearMaxRecoGraphData(); //clear graph data e.g. xaxis, yaxis, series
        this.max_reco_graph_instance.hideLoading(this.loader_default); //disabled loader

        // variables to show no data found labels on graph
        this.is_max_reco_graph_data_available = false;
        ///////////////////////////////////////////
      }

      this.reRenderMaxRecoExpertGraphInstance();

      // serverAddr
      // .post("/stockants_pro/recommendation-graph-by-stock/", {
      //   duration: this.filterObj.target_period.key ? [] : this.filterObj.term == "Short term" ? ["Week", "Month", "Quarter"] : this.filterObj.term == "Long term" ? ["Long_term"] : ["Week", "Month", "Quarter", "Long_term"],
      //   stock_list: this.ranking_board_stock_id_list,
      //   filter: this.filterObj.filters,
      //   sector_list : this.filterObj.sector ? [this.filterObj.sector] : [],
      //   target_period : this.filterObj.target_period
      // })
      // .then(response => {
      //   if(response.data.status){
      //     this.clearMaxRecoGraphData();  //clear graph data e.g. xaxis, yaxis, series
      //     this.max_reco_graph_instance.hideLoading(this.loader_default)     //disabled loader

      //     let max_reco = response.data.data;

      //     if(max_reco.length){

      //       let x_axis = ['experts'];

      //       // to show axis lables vertically
      //       this.$set(this.stacked_bar_graph_xaxis.axisLabel, "rotate", 90);
      //       this.$set(this.stacked_bar_graph_xaxis.axisLabel, "margin", 10);

      //       for(var i=0; i<max_reco.length; i++){
      //         for(var j=0; j<max_reco[i].length; j++){
      //           if(j==0){                               //separated xaxis from 0th index e.g. ['abc', 20, 25]
      //             // splitted large names
      //             // max_reco[i][j] = `${(max_reco[i][j]).split(' ')[0]} ${((max_reco[i][j]).split(' ')[1]).slice(0, 1)}`;
      //             x_axis.push((max_reco[i][j]));
      //           }
      //         }
      //       }

      //       // if max reco lenght is 1 then add this dummy value
      //       //there is issue with displaying single user's 0 value
      //       //two y axis values can't be plot on single x axis thats why we pushed one dummy value
      //       if(max_reco.length  == 1){
      //         x_axis.push('Dummy');
      //       }

      //       this.stacked_bar_graph_dataset.source = max_reco;

      //       [0,1].forEach((element,index) => {
      //           let obj = {};
      //           obj.name = x_axis[index+1];
      //           obj.type = 'bar';
      //           obj.seriesLayoutBy = 'column';
      //           obj.barWidth = 35;
      //           obj.stack = 'stack 1';
      //           obj.label = {
      //             show: true,
      //             position: 'top',
      //             color: '#000',
      //             fontSize: '10',
      //             align: 'right',
      //             // padding: [0,0,3,0],
      //             verticalAlign: 'top',
      //             formatter: function(value, index){
      //               if(value.componentIndex){               //for stacked graph.. componentIndex 0 is first graph and componentIndex 1 second graph..for graph 1 displayd total of graph one and graph second
      //                 return (`${value.data[1] + value.data[2]}`);
      //               }else if(value.componentIndex == 0){
      //                 // return (`${value.data[1]}`);
      //                 return '';
      //               }else{
      //                 return '';
      //               }
      //             }
      //           };
      //           this.stacked_bar_graph_series.push(obj);
      //       });
      //       this.stacked_bar_graph_dataset.source.unshift(x_axis);

      //     }else{
      //       // variables to show no data found labels on graph
      //       this.is_max_reco_graph_data_available = false;
      //       ///////////////////////////////////////////
      //     }
      //     this.reRenderMaxRecoExpertGraphInstance();

      //   }else{
      //     this.clearMaxRecoGraphData();  //clear graph data e.g. xaxis, yaxis, series
      //     this.max_reco_graph_instance.hideLoading(this.loader_default);     //disabled loader
      //     this.reRenderMaxRecoExpertGraphInstance();

      //     // variables to show no data found labels on graph
      //     this.is_max_reco_graph_data_available = false;
      //     ///////////////////////////////////////////
      //   }
      // })
      // .catch(function(error) {
      //   console.log(error);
      //   this.clearMaxRecoGraphData();  //clear graph data e.g. xaxis, yaxis, series
      //   this.max_reco_graph_instance.hideLoading(this.loader_default);     //disabled loader
      //   this.reRenderMaxRecoExpertGraphInstance();

      //   // variables to show no data found labels on graph
      //   this.is_max_reco_graph_data_available = false;
      //   ///////////////////////////////////////////
      // }.bind(this));
    },

    //api to get roi graph data
    getROIGraphData() {
      if (this.top_stock_list.length) {
        this.clearROIGraphData(); //clear graph data e.g. xaxis, yaxis, series

        this.roi_graph_instance.hideLoading(this.loader_default); //disabled loader

        this.horizontal_graph_C_normalised_axis = false; //to show custom formatter

        this.horizontal_bar_graph_xaxis_C.axisLabel.formatter = "{value}%"; //set formatter to xaxis

        this.top_stock_list.forEach((element, index) => {
          let obj = {};
          obj.name = element.name;
          obj.value = element.absolute_roi
            ? element.absolute_roi.toFixed(2)
            : 0;
          obj.itemStyle = { color: this.horizontal_bar_graph_colors[index] };
          obj.label = {
            show: true,
            position: "right",
            fontSize: "10",
            color: "#000",
            formatter: "{c} %",
          };

          this.horizontal_bar_graph_yaxis_C.data.push(element.name);
          this.horizontal_bar_graph_series_C[0].data.push(obj);
        });
      } else {
        this.clearROIGraphData(); //clear graph data e.g. xaxis, yaxis, series
        this.roi_graph_instance.hideLoading(this.loader_default); //disabled loader

        // variables to show no data found on graph
        this.is_roi_graph_data_available = false;
        ///////////////////////////////////////////
      }

      this.reRenderROIGraphInstance();
      // serverAddr
      // .post("/stockants_pro/antestimate-of-stock-graph/", {
      //   duration: this.filterObj.target_period.key ? [] : this.filterObj.term == "Short term" ? ["Week", "Month", "Quarter"] : this.filterObj.term == "Long term" ? ["Long_term"] : ["Week", "Month", "Quarter"],
      //   stock_list: this.ranking_board_stock_id_list,
      //   filter: this.filterObj.filters,
      //   sector_list : this.filterObj.sector ? [this.filterObj.sector] : [],
      //   target_period : this.filterObj.target_period
      // })
      // .then(response => {
      //   if(response.data.status){
      //     this.clearROIGraphData();  //clear graph data e.g. xaxis, yaxis, series
      //     this.roi_graph_instance.hideLoading(this.loader_default);     //disabled loader

      //     this.horizontal_graph_C_normalised_axis = true;    //to show custom formatter

      //     if(response.data.x_axis.length && response.data.y_axis){

      //       this.horizontal_bar_graph_yaxis_C.data = response.data.x_axis;

      //       this.horizontal_bar_graph_xaxis_C.axisLabel.formatter = "{value}";   //set formatter to xaxis

      //       response.data.x_axis.forEach((element,index) => {
      //         let obj = {};
      //         obj.name = element;
      //         obj.value = response.data.y_axis[index];
      //         obj.label = {
      //           show: true,
      //           position: 'right',
      //           fontSize: '10',
      //           color: '#000',
      //           formatter: "{c}"
      //         };
      //         this.horizontal_bar_graph_series_C[0].data.push(obj);
      //       });
      //     }else{
      //       this.is_roi_graph_data_available = false;
      //     }
      //     this.reRenderROIGraphInstance();
      //   }else{
      //     this.clearROIGraphData();  //clear graph data e.g. xaxis, yaxis, series
      //     this.roi_graph_instance.hideLoading(this.loader_default);     //disabled loader
      //     this.reRenderROIGraphInstance();

      //     // variables to show no data found on graph
      //     this.is_roi_graph_data_available = false;
      //     ///////////////////////////////////////////
      //   }
      // })
      // .catch(function(error) {
      //   console.log(error);
      //   this.clearROIGraphData();  //clear graph data e.g. xaxis, yaxis, series
      //   this.roi_graph_instance.hideLoading(this.loader_default);     //disabled loader
      //   this.reRenderROIGraphInstance();

      //   // variables to show no data found on graph
      //   this.is_roi_graph_data_available = false;
      //   ///////////////////////////////////////////
      // }.bind(this));
    },

    //api to get antestimate details graph data
    getAntestimateDetailsGraphData() {
      serverAddr
        .post("/stockants_pro/stock-antestimate-meters/", {
          duration: this.filterObj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          stock_name: this.selected_antestimate_series.name,
          filters: this.filterObj.filters,
          target_period: this.filterObj.target_period,
        })
        .then((response) => {
          if (response.data.status) {
            this.clearAntestimateDetailsGraphData(); //clear graph data e.g. xaxis, yaxis, series
            this.is_antestimate_graph_details_loading = false; //disabled loader

            if (response.data.data) {
              // { value:40, itemStyle: { color: '#000', } }
              this.antestimate_details = response.data.data;

              let obj = {};
              obj.itemStyle = { color: "#000" };

              if (
                this.antestimate_details.Buy > this.antestimate_details.Hold &&
                this.antestimate_details.Buy > this.antestimate_details.Sell
              ) {
                obj.value = this.antestimate_details.Buy;
              } else if (
                this.antestimate_details.Sell > this.antestimate_details.Hold &&
                this.antestimate_details.Sell > this.antestimate_details.Buy
              ) {
                obj.value = this.antestimate_details.Sell;
              } else if (
                this.antestimate_details.Hold > this.antestimate_details.Buy &&
                this.antestimate_details.Hold > this.antestimate_details.Sell
              ) {
                obj.value = this.antestimate_details.Hold;
              } else {
                obj.value = 0;
              }
              this.gauge_graph_series.push(obj);
            }
            this.reRenderAntestimateDetailsGraphInstance();
          } else {
            this.clearAntestimateDetailsGraphData(); //clear graph data e.g. xaxis, yaxis, series
            this.is_antestimate_graph_details_loading = false; //disabled loader
            this.reRenderAntestimateDetailsGraphInstance();
          }
        })
        .catch(
          function(error) {
            console.log(error);
            this.clearAntestimateDetailsGraphData(); //clear graph data e.g. xaxis, yaxis, series
            this.is_antestimate_graph_details_loading = false; //disabled loader
            this.reRenderAntestimateDetailsGraphInstance();
          }.bind(this)
        );
    },

    //api to get trending stock graph data
    getTrendingStockGraphData() {
      this.trending_stock_graph_instance.showLoading(this.loader_default); //enabled loader

      serverAddr
        .get("/performers/v1/stock/trending_stock")
        .then((response) => {
          if (response.data.status) {
            this.clearTrendingStockGraphData(); //clear graph data e.g. xaxis, yaxis, series
            this.trending_stock_graph_instance.hideLoading(this.loader_default); //disabled loader

            if (response.data.y_axis.length) {
              // for(var i=0; i<response.data.x_axis.length; i++){
              //   // response.data.x_axis[i] = `${(response.data.x_axis[i]).split(' ')[0]}  ${((response.data.x_axis[i]).split(' ')[1]).slice(0, 1)}`   //created short labels for xaxis
              //   // response.data.x_axis[i] = `${(response.data.x_axis[i]).split(' ')[0]} ${((response.data.x_axis[i]).split(' ')[1]).slice(0, 1)}`   //created short labels for xaxis
              // }

              // to show axis lables vertically
              this.$set(
                this.custom_bar_graph_series_xaxis.axisLabel,
                "rotate",
                90
              );
              this.$set(
                this.custom_bar_graph_series_xaxis.axisLabel,
                "margin",
                10
              );

              this.custom_bar_graph_series_xaxis.data = response.data.x_axis; //filled x_axis
              response.data.y_axis.forEach((element, index) => {
                let obj = {};
                obj.name = response.data.x_axis[index];
                obj.value = element;
                obj.itemStyle = {
                  color: this.horizontal_bar_graph_colors[index],
                };
                obj.label = {
                  show: true,
                  position: "top",
                  fontSize: "10",
                  color: "#000",
                };

                this.custom_bar_graph_series.data.push(obj); //pushed series obj
              });
            } else {
              this.is_trending_stock_graph_data_available = false;
            }
            this.reRenderTrendingStockGraphInstance();
          } else {
            this.reRenderTrendingStockGraphInstance();
            this.trending_stock_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.clearTrendingStockGraphData(); //clear graph data e.g. xaxis, yaxis, series

            // variables to show no data found labels
            this.is_trending_stock_graph_data_available = false;
            ///////////////////////////////////////////
          }
        })
        .catch(
          function(error) {
            console.log(error);
            this.reRenderTrendingStockGraphInstance();
            this.trending_stock_graph_instance.hideLoading(this.loader_default); //disabled loader
            this.clearTrendingStockGraphData(); //clear graph data e.g. xaxis, yaxis, series

            // variables to show no data found labels
            this.is_trending_stock_graph_data_available = false;
            ///////////////////////////////////////////
          }.bind(this)
        );
    },
  },

  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.header-title-color {
  color: #4269f2;
}

.TopPerformersTopStocks .flex-space-between {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.TopPerformersTopStocks .rank-board-table {
  overflow-x: auto;
  border-spacing: 0;
  border-collapse: collapse;

  .border-right-gray {
    border-right: 1px solid #e9e9e9;
  }

  .border-bottom-gray {
    border-bottom: 1px solid #e9e9e9;
  }

  .bottom-spacing-table-heading {
    padding: 0px 8px 8px 8px;
  }

  width: 100%;

  thead {
    tr {
      th {
        color: #a5a6a8;
        font-size: 13px;
        font-weight: 600;
        padding: 0 5px 5px 5px;
      }
    }

    tr:nth-child(2) {
      border-bottom: 1px solid #e9e9e9;
    }
  }

  tbody {
    tr {
      cursor: pointer;

      td {
        font-size: 12px;
        font-weight: 600;
        text-align: center;
        padding: 15px 10px;
      }
    }

    tr:hover {
      background-color: #eff5fe;
    }

    .selected-row {
      background-color: #eff5fe;
    }
  }
}

.TopPerformersTopStocks .stock-detail-card {
  margin: 10px 0px;
}

.TopPerformersTopStocks .selected-filter-section {
  display: flex;
  margin: 0 15px;

  .filters-content {
    display: flex;
    align-items: center;
    font-size: 0.6rem;
    font-weight: 500;
    background-color: #dde1ed;
    color: #606060;
    border-radius: 50px;
    padding: 3px 10px;
    margin: 0 5px 8px 0;

    i {
      font-size: 0.7rem;
      cursor: pointer;
      font-weight: 600;
      margin: 0 0 0 5px;
    }
  }
}

.TopPerformersTopStocks .stock-base-details {
  background-color: #eff5fe;
  padding: 15px;

  .stock-base-header {
    display: flex;
    width: 100%;
    align-items: start;
  }

  .role-rating-wrapper {
    display: flex;
    align-items: center;

    label {
      font-size: 11px;
      font-weight: 500;
      margin-right: 10px;
    }
  }
}

.stock-accuracy-detail-wrapper {
  padding: 15px;
  min-height: 150px;

  table {
    width: 100%;

    thead {
      th:nth-child(1) {
        text-align: left;
      }

      th {
        font-size: 11px;
        font-weight: 500;
        color: #a5a6a8;
        text-align: center;
        padding: 5px 0 0 0;
      }
    }

    tbody {
      td:nth-child(1) {
        text-align: left;

        div {
          display: flex;
          align-items: center;
          font-size: 10px;
          margin-top: 1px;
        }
      }

      td {
        font-weight: 500;
        text-align: center;
        padding: 5px 0;
      }
    }
  }

  .more-wrapper-btn-section {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .expand_more_wrappers_btn {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 50px;
    height: 20px;
    width: 20px;
    margin: 0px 0px;
    text-align: center;

    .el-icon-arrow-down {
      color: #a5a6a8;
      font-size: 10px;
    }
  }

  .faded-border {
    display: block;
    border: none;
    color: #fff;
    height: 1px;
    background: -webkit-gradient(
      radial,
      50% 50%,
      0,
      50% 50%,
      80,
      from(#ddd),
      to(#fff)
    );
  }
}

@media screen and (max-width: 1200px) {
  .TopPerformersTopStocks .selected-filter-section {
    margin: 15px 10px;
  }

  .TopPerformersTopStocks .rank-board-table {
    th {
      width: 110px;
    }
  }
}

@media screen and (max-width: 575px) {
  .TopPerformersTopStocks .rank-board-table {
    display: block;
  }

  .TopPerformersTopStocks .stock-detail-card {
    margin: 5px !important;
  }

  .TopPerformersTopStocks .stock-accuracy-detail-wrapper {
    padding: 20px 10px;
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.TopPerformersTopStocks .box-card {
  border-radius: 10px !important;
  border: none;
  box-shadow: none;
}

.TopPerformersTopStocks .antestimate-details-card {
  position: absolute;
  right: 0px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1;
  width: 275px;

  .el-card__body {
    padding: 0;
  }

  .close-btn {
    top: 10px;
    right: 15px;
    color: #999;
  }

  .progress-bar-legends {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    margin: 0 10px 0 0;
  }
}

.TopPerformersTopStocks .expert-card {
  min-height: 450px;
}

.TopPerformersTopStocks .expert-card .el-card__body {
  padding: 20px 0;
}

.TopPerformersTopStocks .stock-detail-card .el-card__body {
  padding: 0px 0;
}

.TopPerformersTopStocks .NoDataFound {
  padding: 60px 0 0 0;
}

.TopPerformersTopStocks .el-icon-download,
.el-icon-share {
  margin: 0 12px;
}

.TopPerformersTopStocks .el-rate__icon {
  margin-right: 0px !important;
  font-size: 14px !important;
}

.TopPerformersTopStocks .el-pager li.active {
  color: #3f67f2;
}

.TopPerformersTopStocks .el-loading-mask {
  z-index: 1;
}

.TopPerformersTopStocks .role-rating-wrapper .el-rate__icon {
  font-size: 10px !important;
}

.el-tooltip__popper {
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600 !important;
}

.stock-ranking,
.sector-ranking {
  .no-data-container {
    max-width: 225px !important;
  }
}
</style>
